<template>
  <ul class="members-avatar-list d-flex align-items-center mb-0">
    <li
      v-for="(member, index) in membersList.slice(0, limit)"
      :key="index"
      :id="'user-' + uuid + '-' + member.user.id"
      class="member-avatar"
    >
      <user-short :user-id="member.user.id" :length="avatarSize"></user-short>
      <b-popover
        :target="'user-' + uuid + '-' + member.user.id"
        triggers="hover"
        placement="bottom"
        custom-class="members-list-popover"
      >
        <div class="d-flex text-medium">
          <div>
            <user-short :user-id="member.user.id" length="50"></user-short>
          </div>
          <div class="pl-2 pt-1">
            <div class="d-flex">
              <router-link
                :to="getUserPageLocation(member.user.id)"
                class="flex-grow-1 text-primary"
              >
                <b class="pr-4" v-no-capture>{{ member.user.displayName }}</b>
              </router-link>
              <i class="owner-icon" v-if="member.type === 'owner'"></i>
            </div>
            <div v-if="member.type === 'owner'" class="text-secondary">
              <template v-if="teamId">
                {{ team.isOrgLike ? 'Org ' : 'Team ' }}
              </template>
              Owner
            </div>
            <div class="text-secondary" v-no-capture>{{ member.user.email }}</div>
            <router-link
              class="d-block mt-2 pt-1"
              :to="getUserPageLocation(member.user.id)"
              v-no-capture
            >
              See {{ member.user.firstName }}'s Goals
            </router-link>
          </div>
        </div>
      </b-popover>
    </li>
    <li v-if="membersList.length > limit">
      <b-button
        class="show-more-button text-secondary text-small"
        variant="light"
        id="showMoreUsers"
        :style="{ height: `${avatarSize}px`, width: `${avatarSize}px` }"
        pill
        >{{ membersList.length - limit }}
      </b-button>
      <b-popover
        target="showMoreUsers"
        triggers="hover"
        placement="bottom"
        custom-class="show-more-popover"
      >
        <ul class="mb-0 text-medium-1">
          <li
            class="d-flex align-items-baseline py-2"
            v-for="(member, index) in membersList.slice(limit)"
            :key="index"
          >
            <user-short class="d-block" :user-id="member.user.id" length="26"></user-short>
            <router-link
              :to="getUserPageLocation(member.user.id)"
              class="text-primary align-self-center member-name"
            >
              <span class="pl-2 d-block" v-no-capture>
                <span class="display-name">{{ member.user.displayName }}</span>
                <span class="text-secondary text-small" v-if="member.type === USER_TYPE.OWNER"
                  >(Owner)</span
                >
              </span>
            </router-link>
          </li>
        </ul>
      </b-popover>
    </li>
  </ul>
</template>

<script>
import UserShort from '@/components/UserShort.vue'
import { USER_TYPE } from '@/constants/user'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import { getUserPageRouteConfig } from '@/utils/navigationConfigs'
import { BButton, BPopover } from 'bootstrap-vue'

export default {
  name: 'MembersList',
  props: ['membersList', 'limit', 'teamId', 'subOrgId', 'orgId', 'avatarSize'],
  components: {
    BPopover,
    UserShort,
    BButton
  },
  data() {
    return {
      USER_TYPE
    }
  },
  mixins: [ComponentIdMixin],
  computed: {
    team() {
      return this.teamId && this.$store.getters.teamById(this.teamId)
    }
  },
  methods: {
    getUserPageLocation(userId) {
      const route = getUserPageRouteConfig({ orgId: this.orgId, userId, subOrgId: this.subOrgId })
      return route
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.members-avatar-list {
  list-style: none;
  padding: 0;
  margin-top: 4px;
}

.member-avatar {
  display: inline-flex;

  &:not(:last-child) {
    margin-right: 6px;
  }
}

.show-more-popover ul {
  list-style: none;
  padding: 0;
}

.show-more-popover /deep/ .popover-body {
  width: 250px;
  max-height: 300px;
  overflow-y: auto;
}

.show-more-button {
  padding: 0;
}
.member-name:hover {
  text-decoration: none;
  .display-name {
    text-decoration: underline;
  }
}
</style>
